import AppointmentList from "views-interpreters/AppointmentList";
import Dashboard from "views-interpreters/Dashboard";
import Payments from "views-interpreters/Payments";
import Profile from "views-interpreters/profile";
import ChangePassword from "views/ChangePassword";


var routesInterpreters = [
  {
    path: "/dashboard",
    title:"Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/interpreter",
  },
  {
    path: "/appointments",
    title:"Appointments",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <AppointmentList />,
    layout: "/interpreter",
  },
  {
    path: "/payments",
    title: "Payments",
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component:  <Payments/>,
    layout: "/interpreter",
  },
  {
    path: "/profile",
    subRoute: true,
    component:  <Profile/>,
    layout: "/interpreter",
  },
  {
    path: "/change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/interpreter",
  },
];
export default routesInterpreters;
